import React from "react";
import styles from "./PageLoader.module.css";

const PageLoader = ({ text = "Loading..." }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.loaderBox}>
        <div className={styles.spinner} />
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  );
};

export default PageLoader;